import { ScreenView } from '../../../constants/global.constant';
import { Address, Image, TooltipContent } from '../../../shared/shared.interface';

export interface KngCardList {
  state: KngCardListState;
}
export interface KngCardListState {
  view:
  | ScreenView.accordionMobile
  | ScreenView.accordionDeskTop
  | ScreenView.tableDesktop
  | ScreenView.tableMobile;
  header: Array<KngHeaderObjState>;
  list: Array<KngValueObjState>;
  cardListGrayIcon?: { url: string; alt: string };
  cardListOrangeIcon?: { url: string; alt: string };
  cardListAccordionIcon?: { url: string; alt: string };
  actionOpsList?: Array<ActionOpsList>;
  userStatusOption?: Array<StatusOptionList>;
  pageInfo: PageInfo;
  error?: ErrorMessage;
  tooltipMessage?: string;
  serviceCampaignAltText?:string;
  moreIconAltText?:string;
  loading: boolean;
  activeIndex?: number;
  hideSort?: boolean;
  hidePagination?: boolean;
  activeFlag?:string|undefined;
  connectedIcon?: Image | undefined;
  errorIcon?: Image | undefined;
}
export interface ErrorMessage {
  message: string | undefined;
  messageSubText: string | undefined;
  icon: string;
}

export interface KngHeaderObjState {
  label: string;
  isSort: boolean;
  isTooltipPresent?: boolean;
  tooltip?: TooltipContent;
  tooltipClass?: string;
  sortOrder: SortOrder;
  hideSort?:boolean;
  category?: string;
}

export interface KngValueObjState {
  collapsed: boolean;
  values: Array<KngValueListState>;
  id?:string;
  customerId?:string;
  subscriptionRenewalDate?: string;
  locationObj?: Address;
  orderId?: string;
  locationId? : string;
  documentURL? :  string | undefined;
  locationLabel?: string | undefined;
  equipmentAddressLabel?: string | undefined;
  isLabelEditable?: boolean;
  techinicalObjectType?: string;
  managedBy?: string;
  serialNumber?: string;
  checked?: boolean;
  changeRequest?: {
    display: string;
    tooltip: string;
    toastMessage: string;
    bannerMessage: string;
  };
  manufacturer?: string;
  autoRenew?: boolean;
  subscriptionId?: string;
  endDate?: string;
  accountNumber?: string;
  subscriptionAddress?: string;
}

export interface KngValueListState {
  id?:string;
  label: string;
  labelValue: string | boolean | number;
  icon?: string;
  cssClass: string;
  href?: string;
  category?: string;
  serviceCampaign?: boolean;
  currency?: string;
  isTooltipPresent?: boolean;
  tooltip?: TooltipContent;
  tooltipClass?: string;
  isError?: boolean;
  errorIcon?: Image;
  isStatusUpdatePending?: boolean;
  statusUpdatePendingMessage?: string;
  displayType?: {
    separator: string;
    styleChange?: string;
  };
  subscriptionTerm? : {
    date: string;
    fontClass: string;
};
  addressInfo?: {
    locationLabel: string;
    address: string;
  };
}
export interface KngGridPager {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  startPage: number;
  endPage: number;
  startIndex: number;
  endIndex: number;
}

export interface ActionOpsList {
  actionLabel?: string;
  disabled?: boolean;
}
export interface StatusOptionList {
  id: number;
  label: string;
}
export interface StatusChangeOptionList {
  id?: string;
  userStatus: string | number | boolean;
}


export interface TableButtonAction {
  category?: KngValueObjState;
  action?: ActionOpsList;
}


export enum FieldType {
  action = 'action',
  indicator = 'indicator',
  text = 'text',
  link = 'link',
  currency = 'currency',
  primaryText = 'primary-text',
  date = 'date',
  dateString = 'dateString',
  invoice = 'invoice',
  userStatus = 'userStatus',
  orderStatus='primaryStatus',
  restrictedLink = 'restricted-link',
  crStatus = 'status',
  image = 'image',
  address='address',
  myQuoteStatus='myQuoteStatus',
  dealershipInfo='dealershipInfo',
  pdf='pdf',
  serviceCampaign='serviceCampaign',
  telematicsStatus = 'telematicsStatus',
  subscription = 'subscription',
  operatorHour = 'operatorHours',
  subscriptionPlan = 'subscriptionPlan',
  subscriptionTerm = 'subscriptionTerm',
  equipmentAddress = 'equipmentAddress',
  locationLabel = 'locationLabel',
  primarySubLocation = 'primarySubLocation',
  deleteRow = 'deleteRow'
}

export enum InvoiceStatus {
  pastDue = 'Past Due',
  open = 'Open',
  upcoming = 'Upcoming',
  paid = 'Paid'
}
export enum ChangeRequestIndicator {
  awaitingApproval = 'Awaiting Approval',
  approved = 'Approved',
  cancelled = 'Cancelled'
}
export enum EquipmentOrderStatus {
  orderInProcess = 'In Process',
  inProduction = 'In Production',
  shipped = 'Shipped',
  delivered = 'Delivered',
  cancelled='Cancelled'
}

export enum OrderClassList {
  orderInProcess = 'order-in-process',
  inProduction = 'in-production',
  shipped = 'shipped',
  delivered = 'delivered',
  cancelled = 'cancelled'
}

export enum SubscriptionClassList {
  nosub = 'nosub',
  myInsightCompliance = 'myInsightCompliance'

}
export enum SubscriptionType {
  noSubscription = 'No Subscription',
  myinsights = 'MyInsights Plus',
  myinsightscompliance = 'MyInsights Plus Compliance'
}
export enum MyQuoteStatus {
  quoteinProcess = 'In Process',
  quoteAccepted = 'Accepted',
  ordered = 'Ordered',
  expired = 'Expired',
  readyForReview = 'Ready for Review'
}
export interface PageInfo {
  pageSize: number;
  totalCount: number;
}

export enum SortOrder {
  desc = 'desc',
  asc = 'asc',
}

export enum ActionLabel {
  editLocationLabel = 'Edit Location Label',
  cancelRenewal = 'Cancel Renewal'
}
export interface TelematicsResponse {
  connected: boolean;
  notConnected: boolean;
  error: boolean;
}

export enum TelematicsStatus {
  connected = 'connected',
  notConnected = 'notConnected',
  error = 'error'
}
export enum InvoiceCheck {
  invoice = 'Invoice'
}

export interface CheckboxChangeEvent {
  item: KngValueObjState;
  isChecked: boolean;
  index: number;
}
